// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'recurring-journal-entry.page.create.title': 'Create Recurring Journal Entry',

    'recurring-journal-entry.button.cancel': 'Cancel',
    'recurring-journal-entry.button.draft': 'Save as Draft',
    'recurring-journal-entry.button.save': 'Save Entries',
    'recurring-journal-entry.button.add': 'Add Entry',
    'recurring-journal-entry.button.create': 'New Entry',

    'recurring-journal-entry.link.create_first_journal_entry': 'Click here to create your first journal entry',
    'recurring-journal-entry.link.retry': 'Click here to retry',

    'recurring-journal-entry.label.debit': 'Debit',
    'recurring-journal-entry.label.credit': 'Credit',
    'recurring-journal-entry.label.journal_entry_batch_name': 'Journal Entry',
    'recurring-journal-entry.label.general_ledger_account': 'Account',
    'recurring-journal-entry.label.entity_name': 'Contact',
    'recurring-journal-entry.label.next_run_date': 'Next Run Date',
    'recurring-journal-entry.label.memo': 'Memo',

    'recurring-journal-entry.success.message.journal_entry_created': 'Your journal entries have been recorded',

    'recurring-journal-entry.error.message.unbalanced': 'Total Debits must equal Total Credits',
    'recurring-journal-entry.error.message.error_loading_page': 'Sorry, there was an error loading journal entry.| Sorry, there was an error loading journal entries.',

    'recurring-journal-entry.frequency-once': 'Once',
    'recurring-journal-entry.frequency-weekly': 'Weekly',
    'recurring-journal-entry.frequency-monthly': 'Monthly',
    'recurring-journal-entry.frequency-monthly-specific-day': 'Monthly with set day',
    'recurring-journal-entry.frequency-yearly': 'Yearly',

    'recurring-journal-entry.label.term': 'Term',
    'recurring-journal-entry.label.frequency': 'Frequency',
    'recurring-journal-entry.label.from_date': 'From Date',
    'recurring-journal-entry.label.thru_date': 'Thru Date',
    'recurring-journal-entry.label.day': 'Recurrence Day',
};
